import { BaseUrl, post } from './api'

export const uploadEventLog = async (eventLog) => {
  return await post(`api/Audit/upload`, BaseUrl.Api, eventLog);
}

